<template>
  <div class="mt-2 mb-2 text-left">
    <b-btn variant="primary" class="mt-2 mb-2" v-on:click="runReport" v-if="flagShowOwnRunButton">{{ pLabelRunButton }}</b-btn>
    <div v-if="reportData && reportData.length > 0">
      <report-table :data="reportData" :columnFormatters="reportColumnFormatters"></report-table>
    </div>
  </div>
</template>

<script>
import ManagerRequest from '@/services/ManagerRequest';
import apiClient      from '@/services/HttpRequestService';
import ReportModel    from '@/models/mReport';
import ReportTable    from '@/components/reports/ReportTable';
import UtilsData      from '@/utilities/UtilsData';
import ObjAlertState  from '@/components/common/alert/ObjAlertState';

export default {
  name: 'reportSingleExecutor',
  props: {
    pLabelRunButton: {
      type: String,
      default: 'Run Historical Report'
    },
    pReportName: {
      type: String,
      default: null
    },
    pReportParams: {
      type: Array,
      default: null
    },
    triggerRunReport: {
      type: Boolean,
      default: false
    },
    flagShowOwnRunButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      reportData: null,
      reportColumnFormatters: []
    };
  },
  methods: {
    async runReport() {
      const name = this.pReportName;
      const params = this.pReportParams;
      const id = await this.getHistoricalReportIdByName(name);
      if (UtilsData.isEmpty(id)) {
        ObjAlertState.set(`Sorry, but the report ${name} is not available.`, 3);
        return null;
      }
      const reportModelInstance = await this.createReportModelWithId(id);
      reportModelInstance.mapUdfParameters(params);
      this.reportData = await reportModelInstance.run();
      if (UtilsData.isEmpty(this.reportData)) {
        return;
      }
      this.$emit('onReportDataReceived', this.reportData);
      reportModelInstance.loopReportData();
      this.reportColumnFormatters = reportModelInstance.getColumnFormatters();
    },
    async createReportModelWithId(id, isHistorical = true) {
      const model = new ReportModel({}, isHistorical);
      model.ats.Id = id;
      await model.get();
      return model;
    },
    async getHistoricalReportIdByName(name) {
      const reportList = await (new ManagerRequest(
        apiClient.getHistoricalReportsList,
        apiClient,
        []
      ))
        .do();
      const arrRes = reportList.filter(r => r.Name === name);
      return (arrRes.length > 0) ? arrRes[0].Id : null;
    }
  },
  watch: {
    triggerRunReport: async function() {
      await this.runReport();
    }
  },
  components: {
    ReportTable
  }
};
</script>

<style scoped lang='scss'>
</style>
